export default __webpack_public_path__ + "static/media/favicon.d3f9df5a.ico";